import { create } from 'zustand'
import { arrayIcons } from './reporteIcon'

const DEFAULT_FAVORITE_IDS = ['2', '3', '4', '6']

const DEFAULT_FAVORITE_ICONS = arrayIcons
  .filter(icon => DEFAULT_FAVORITE_IDS.includes(icon.id))
  .map(({ id, title, tooltip }) => ({ id, title, tooltip }))
  .sort((a, b) => Number(a.id) - Number(b.id))

const readStoredArray = key => {
  try {
    const rawValue = localStorage.getItem(key)
    const parsedValue = rawValue ? JSON.parse(rawValue) : null
    return Array.isArray(parsedValue) ? parsedValue : null
  } catch {
    return null
  }
}

const initialFavoriteIcons = readStoredArray('favoriteIcons') ?? DEFAULT_FAVORITE_ICONS
const initialClickedIcons = new Set(readStoredArray('clickedIcons') ?? DEFAULT_FAVORITE_IDS)

if (!localStorage.getItem('favoriteIcons')) {
  localStorage.setItem('favoriteIcons', JSON.stringify(initialFavoriteIcons))
}

if (!localStorage.getItem('clickedIcons')) {
  localStorage.setItem('clickedIcons', JSON.stringify([...initialClickedIcons]))
}

export const useContentTypeReportes = create(set => ({
  typeContent: '0',
  setTypeContent: value => set(() => ({ typeContent: value })),
  resetTypeContent: () => set(() => ({ typeContent: '0' })),
  favoriteContent: null,
  setFavoriteContent: value => set(() => ({ favoriteContent: value })),
  favoriteIcons: initialFavoriteIcons,
  clickedIcons: initialClickedIcons,
  addFavoriteIcon: icon =>
    set(state => {
      if (!state.clickedIcons.has(icon.id)) {
        const { id, title, tooltip } = icon
        const updatedFavoriteIcons = [...state.favoriteIcons, { id, title, tooltip }]
        const sortedFavoriteIcons = updatedFavoriteIcons.sort((a, b) => Number(a.id) - Number(b.id))
        const updatedClickedIcons = new Set([...state.clickedIcons, icon.id])

        localStorage.setItem('favoriteIcons', JSON.stringify(sortedFavoriteIcons))
        localStorage.setItem('clickedIcons', JSON.stringify([...updatedClickedIcons]))

        return {
          favoriteIcons: sortedFavoriteIcons,
          clickedIcons: updatedClickedIcons
        }
      }
      return state
    }),
  removeFavoriteIcon: iconId =>
    set(state => {
      const updatedFavoriteIcons = state.favoriteIcons.filter(icon => icon.id !== iconId)
      const updatedClickedIcons = new Set([...state.clickedIcons].filter(id => id !== iconId))
      localStorage.setItem('favoriteIcons', JSON.stringify(updatedFavoriteIcons))
      localStorage.setItem('clickedIcons', JSON.stringify([...updatedClickedIcons]))

      return {
        favoriteIcons: updatedFavoriteIcons,
        clickedIcons: updatedClickedIcons
      }
    })
}))
